// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { useEffect } from 'react';
import { isNativePlatform } from '../utils/platform';

/**
 * Handles the Android hardware back button in a Capacitor native shell.
 * Navigates back in browser history, or does nothing if at the root.
 * No-op on web platform.
 */
export function useBackButton(): void {
  useEffect(() => {
    if (!isNativePlatform()) return;

    let cleanup: (() => void) | undefined;

    import('@capacitor/app').then(({ App }) => {
      App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        }
        // At root: do nothing (don't exit app — user can swipe or use home button)
      }).then((handle) => {
        cleanup = () => handle.remove();
      });
    });

    return () => {
      cleanup?.();
    };
  }, []);
}
